<template>
	<div class="iot-detail pa-content">
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>  
			</div>
		</transition>
		<div class="container">
			<div class="iot-title">
				<h3>{{ langs.iot3 }}{{ langs.iot5 }}</h3>
				<div class="curr-localtion">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/' }">{{ langs.header1 }}</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/iotManage' }">{{ langs.index8 }}</el-breadcrumb-item>
						<el-breadcrumb-item>{{ langs.iot3 }}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			<el-row>
				<el-col :xs="24" :md="6" class="iot-box-nav">
					<ul class="iot-nav">
						<li>
							<router-link to="/iotManage/iotdetail1"><span class="iottips ws">{{ langs.index9 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
						<li>
							<router-link to="/iotManage/iotdetail2"><span class="iottips ws">{{ langs.index11 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
						<li>
							<router-link to="/iotManage/iotdetail3"><span class="iottips ws">{{ langs.index12 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
						<li class="active">
							<router-link to="/iotManage/iotdetail4"><span class="iottips ws">{{ langs.iot3 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
						<li>
							<router-link to="/iotManage/iotdetail5"><span class="iottips ws">{{ langs.iot4 }}</span>		<i class="el-icon-caret-right fr"></i></router-link>
						</li>
					</ul>
				</el-col>
				<el-col :xs="24" :md="18" class="iot-box-img">
					<div class="iot-box scroll-container">
						<div class="iot-box-text1 iot-text wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div>
								<span class="iot-text-tit">{{ langs.iot16 }}</span>
								{{ langs.iot166 }}
							</div>
						</div>
						<div class="iot-m iot-m1 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot17 }}</h1>
							<el-image :src="require('../../static/images/iot/m1.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m1.png" ></img> -->
						</div>
						<div class="iot-m iot-m2 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot18 }}</h1>
							<el-image :src="require('../../static/images/iot/m2.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m2.png" ></img> -->
						</div>
						<div class="iot-m iot-m3 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot19 }}</h1>
							<el-image :src="require('../../static/images/iot/m3.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m3.png" ></img> -->
						</div>
						<div class="iot-m iot-m4 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot20 }}</h1>
							<el-image :src="require('../../static/images/iot/m4.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m4.png" ></img> -->
						</div>
						<div class="iot-m5 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<el-image :src="require('../../static/images/iot/m5.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m5.png" ></img> -->
						</div>
						<div class="iot-m6 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<el-image :src="require('../../static/images/iot/m6.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m6.png" ></img> -->
						</div>
						<div class="iot-m iot-m7 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot21 }}</h1>
							<el-image :src="require('../../static/images/iot/m7.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m7.png" ></img> -->
						</div>
						<div class="iot-m iot-m8 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot22 }}</h1>
							<el-image :src="require('../../static/images/iot/m8.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m8.png" ></img> -->
						</div>
						<div class="iot-m iot-m9 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot23 }}</h1>
							<el-image :src="require('../../static/images/iot/m9.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m9.png" ></img> -->
						</div>
						<div class="iot-m iot-m10 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot24 }}</h1>
							<el-image :src="require('../../static/images/iot/m10.png')" lazy></el-image>
							<!-- <img src="../../static/images/iot/m10.png" ></img> -->
						</div>
						<div class="iot-m iot-m11 wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<h1>{{ langs.iot25 }}</h1>
							<el-image :src="require('../../static/images/iot/m11.png')" lazy></el-image>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		name: 'iotdetail4',
		data() {
			return {
				showLoading: true,
				
				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh, 
			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoading = false;
			}, 500)
		},
		mounted() {
			let _this = this;
			_this.$nextTick(() => { // 在dom渲染完后,再执行动画
				var wow = new WOW({
					boxClass: 'wow',///动画元件css类（默认为wow）
					animateClass: 'animated',//动画css类（默认为animated） 
					offset: 0,//到元素距离触发动画（当默认为0） 
					mobile: true, //在移动设备上触发动画（默认为true） 
					live: true//对异步加载的内容进行操作（默认为true）
				})
				wow.init()
			})
			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.iot-title{
		border: 1px solid #eee;
		margin: 15px 0px;
		color: #333;
	}
	.iot-title h3{
		display: inline-block;
		margin: 0px;
		padding: 10px 12px;
		border-left: 3px solid #409EFF;
	}
	.iot-title .curr-localtion{
		float: right;
		margin-top: 15px;
		margin-right: 10px;
	}
	/* iot导航 */
	.iot-nav{
		padding: 0px 15px;
	}
	.iot-nav li{
		cursor: pointer;
		font-size: 18px;
		border-bottom: 1px solid #eee;
	}
	.iot-nav li a{
		display: block;
		padding: 15px 5px 10px;
	}
	.iot-nav li i{
		margin-right: 5px;
	}
	.iot-nav li.active a{
		background-color: #409EFF;
		color: #fff;
	}
	.iot-box{
		font-size: 15px;
		line-height: 24px;
		margin-bottom: 100px;
	}
	.iot-text-tit{
		font-size: 16px;
		color: #409EFF;
	}
	.iot-text >div{
		margin-bottom: 15px;
	}
	.iot-m{
		margin-top: 50px;
	}
	@media screen and (max-width:768px) {
		.iot-title h3{
			display: block;
			border-bottom: 1px solid #eee;
		}
		.iot-title .curr-localtion{
			float: none;
			margin: 8px 15px;
			display: block;
		}
		.iot-box-nav{
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/iotdetail4.vue